import React from "react"

import Section from "@components/section"
// import Bottom from "./superSmashBros_bottom"

const En = () => {
  return (
    <>
      <Section title="Tournament Info">
        <table className="tableInfo">
          <tbody>
            <tr>
              <td>Schedule (Streaming)</td>
              <td>
                Oct 17h (Saturday) 13:00 - 14:30 Team A <br />
                Oct 17h (Saturday) 14:30 - 16:00 Team B <br />
                Oct 18th (Sunday) 13:00 - 14:30 Team C <br />
                Oct 18th (Sunday) 14:30 - 16:00 Team D <br />
                Oct 24th (Saturday) 13: 00 Top 8 Final <br />
                <br />
                <br />
                <a href="https://www.huya.com/spark2020" target="_blank">
                  Streaming : huya 660161
                </a>
              </td>
            </tr>
            <tr>
              <td>Type</td>
              <td>Online Tournament</td>
            </tr>
            <tr>
              <td>System</td>
              <td>Double Elimination</td>
            </tr>
            <tr>
              <td>Rules</td>
              <td>
                Platform：Steam
                <br />
                Best 2 out of 3 for Pools
                <br />
                Best 3 out of 5 for Top 8<br />
                99 seconds, 2/3 Rounds
                <br />
                The player who won the last Game is required to keep the same
                character, however they can change their V-Trigger and V-Skill
                as long as their new V-Trigger and V-Skill choice is made before
                their opponent selects their own V-Trigger and V-Skill.
                <br />
                The use of the costumes and colors listed in the table at the
                bottom are prohibited. <br />
              </td>
            </tr>
            <tr>
              <td>Stages</td>
              <td>
                Stages are banned：
                <br />
                Kanzuki Beach; Flamenco Tavern; Skies of Honor; <br />
                Field of Fate and Mysterious Cove stages.
              </td>
            </tr>
            <tr>
              <td>Game version</td>
              <td>Latest version</td>
            </tr>
            <tr>
              <td>Season 3 Tournament Reward</td>
              <td>
                1st : 4000
                <br />
                2nd : 2000
                <br />
                3rd : 1000
                <br />
              </td>
            </tr>
          </tbody>
        </table>
      </Section>
      <Section title="Notice of Contest">
        <div className="tips">
          <p>
            1.Wireless (WiFi) connections are prohibited, in order to ensure the
            stability of the tournament, players need to use wired connections.
          </p>

          <p>
            2.After the registration deadline, lots will be drawn by GAMECORES,
            the whole process will be issued to the chat group for confirmation.
          </p>

          <p>
            3.All team needs to have a proper connection to ensure smooth live
            streaming, and prepare for the contest in any moment. Please confirm
            your time before signing up.
          </p>

          <p>
            4.Any team is five minutes late or does not participate because of
            failure to arrive, leave early and other reasons, the team will be
            disqualified and the team's opponent will be awarded the victory.
          </p>

          <p>
            5.The ID, avatar, team name, clothing, carrying items, etc. of the
            player shall not contain any text, patterns or elements that include
            violation of the laws and regulations of the country or not suitable
            for appearance in the live broadcast of the contest. Any of the
            above prohibition, once verified, the team will be disqualified and
            stripped of their results;
          </p>

          <p>
            6.Players shall not make statements that violate national laws and
            regulations, insult or other statements that are not suitable for
            appearance in the live broadcast. In the event of the above
            prohibition, the team will be disqualified and stripped of their
            results.
          </p>

          <p>
            7.The GAMECORES CO. reserves all the right for final interpretation
            of the Contest.
          </p>
        </div>
      </Section>
      {/* <Bottom isEn /> */}
      <Section title="Costumes & Colors Restrictions">
        <div className="tableRank">
          <table>
            <thead>
              <tr>
                <th>Character</th>
                <th>Costume（Color）</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Barlrog</td>
                <td>Gutsman</td>
              </tr>

              <tr>
                <td>Blanka</td>
                <td>Story</td>
              </tr>

              <tr>
                <td>Blanka</td>
                <td>Nergigante</td>
              </tr>

              <tr>
                <td>Ed</td>
                <td>Nero</td>
              </tr>

              <tr>
                <td>Gill</td>
                <td>Pyron</td>
              </tr>

              <tr>
                <td>M. Bison</td>
                <td>Astaroth</td>
              </tr>

              <tr>
                <td>Necalli</td>
                <td>Halloween</td>
              </tr>

              <tr>
                <td>R. Mika</td>
                <td>Professional</td>
              </tr>

              <tr>
                <td>Rashid</td>
                <td>Airman</td>
              </tr>

              <tr>
                <td>Rashid</td>
                <td>Viewtiful Joe</td>
              </tr>

              <tr>
                <td>Ryu</td>
                <td>Mega Man</td>
              </tr>

              <tr>
                <td>Urien</td>
                <td>Halloween</td>
              </tr>

              <tr>
                <td>Urien</td>
                <td>Wesker</td>
              </tr>

              <tr>
                <td>Zangief</td>
                <td>Mech（02）</td>
              </tr>

              <tr>
                <td>Abigail</td>
                <td>Halloween（02）</td>
              </tr>

              <tr>
                <td>Urien</td>
                <td>Story（06）</td>
              </tr>

              <tr>
                <td>Urien</td>
                <td>Battle Outfit1（07）</td>
              </tr>

              <tr>
                <td>Gill</td>
                <td>Battle Outfit1（11）</td>
              </tr>

              <tr>
                <td>Gill</td>
                <td>Battle Outfit1（15）</td>
              </tr>

              <tr>
                <td>All Characters</td>
                <td>Default Costume（EX10）</td>
              </tr>

              <tr>
                <td>All Characters</td>
                <td>Default Costume（EX10）</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Section>
    </>
  )
}

export default En
